import { extractNewAiSource, LikeOrDislike } from "@me8eon/feedback";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { DislikeOptions } from "../molecules/DislikeOptions";
import { FeedbackOptions } from "../molecules/FeedbackOptions";
import { useTranslation } from "@me8eon/translation";
import { FeedbackSupportActions } from "../molecules/FeedbackSupportActions";
import { AiAssistContext, useAiAssistContext } from "../../../components/ai-assist-refactored/AiAssist.context";
import { useFeedback } from "@me8eon/feedback";
import { useUserData } from "@me8eon/react_authentication";


export const Feedback = () => {
    const t = useTranslation();
    const [selected, setSelected] = useState<LikeOrDislike | undefined>(undefined);
    const [feedbackText, setFeedbackText] = useState<string>("");
    const { currentAgent } = useContext(AiAssistContext);
    const feedback = useFeedback();
    const { company, currentRole } = useUserData();
    const { actualMessages } = useAiAssistContext();

    useEffect(() => {
        if (selected === "like") {
            setFeedbackText("");
        }
    }, [selected]);

    const getLastObj = (val: string) => {
        const lastUserMessage = [...actualMessages].reverse().find(m => m.role === val);
        return lastUserMessage?.content as string || "";
    }

    useEffect(() => {
        if (feedbackText) {
            const aiResponse = getLastObj("assistant");
            feedback({
                source: "freeTextFromChat",
                text: feedbackText,
                likeDislike: selected,
                like: selected,
                classification: { category: currentAgent || "NA" },
                query: getLastObj("user") as string,
                answer: aiResponse,
                sourceFromAnswer: extractNewAiSource(aiResponse),
                company: company || "unknown",
                role: currentRole || "unknown"
            });
        }
    }, [feedbackText])

    return (
        <div className="feedback" style={{ padding: "0 16px" }}>
            <FeedbackOptions
                setSelected={setSelected}
                selected={selected}
                getLastObj={getLastObj}
                isFeedbackSend={!!selected} />
            {selected === "dislike" &&
                <DislikeOptions feedbackText={feedbackText} setFeedbackText={setFeedbackText} loading={!!feedbackText} />}
            {(selected === "like" || (selected === "dislike" && feedbackText)) && (<div className="feedback-response">
                <div className="feedback-message-wrapper">
                    <p className="feedback-message">
                        {t("chatBot.feedbackMessage")}
                    </p>
                </div>
            </div>)}
            {selected === "dislike" && currentAgent === "itsupport" && (
                <FeedbackSupportActions isFeedbackSend={!!feedbackText} />
            )}
        </div>
    )

}